<template>
    <div class="projects-learning">

        <div class="content">
            
            <content-switch
            :items="switchItems"
            :selectedItem="selectedItem"
            :counts="counts"
            @selectItem="handleSelectItem($event)" />

            <div class="row" v-show="selectedItem === 'projectTypeRevenue'">
                <div :class="{'col-lg-6': !selectedProjectType, 'col-lg-3': selectedProjectType}">
                    <projectTypeRevenue-table title="Hvilke opgavetyper tjenes der penge på?" @selectProjectType="setSelectedProjectType($event)" @finishedLoading="updateCount('projectTypeRevenue', $event)" />
                </div>
                <div v-if="selectedProjectType" class="col-lg-9">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedProjectType = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                    <showTypeRevenue-table :rows="$store.getters.groupedProjects[selectedProjectType]" title="Konkrete opgaver" />
                </div>
                <div v-else class="col-lg-6">
                    Vælg en opgavetype for at se en liste over alle opgaver og deres konkrete indtjening.
                </div>
            </div>
            
            <closedProjects-table title="Hvilke konkrete opgaver tjenes der penge på?" v-show="selectedItem === 'closedProjectsRevenue'" @finishedLoading="updateCount('closedProjectsRevenue', $event)" />
            
            <project-type-skills v-show="selectedItem === 'projectTypeSkills'" />

            <project-type-development v-show="selectedItem === 'projectTypeDevelopment'" />

            <project-type-coverage-per-hour-development v-show="selectedItem === 'coveragePerHourPerProjectTypeDevelopment'" />

            <claims-table v-show="selectedItem === 'claims'" @finishedLoading="updateCount('claims', $event)" />

            <div class="placeholder">

                <div v-show="selectedItem === 'closedProjectsRevenue'">                        
                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            selectedProjectType: null,
            selectedItem: 'projectTypeRevenue',
            counts: {
                projectTypeRevenue: null,
                closedProjectsRevenue: null,
                claims: null
                // projectTypeSkills: null
                // projectTypeDevelopment: null,
                // coveragePerHourPerProjectTypeDevelopment: null
            },
            switchItems: [
                {
                    name: 'Hvilke opgavetyper tjenes der penge på?',
                    slug: 'projectTypeRevenue'
                },
                {
                    name: 'Hvilke konkrete opgaver tjenes der penge på?',
                    slug: 'closedProjectsRevenue'
                },
                {
                    name: 'Afsluttede reklamationer',
                    slug: 'claims'
                },
                {
                    name: 'Hvilke svende er gode til hvilke opgaver?',
                    slug: 'projectTypeSkills'
                },
                {
                    name: 'Udviklingen i DB',
                    slug: 'projectTypeDevelopment'
                },
                {
                    name: 'Udviklingen i DB pr. time',
                    slug: 'coveragePerHourPerProjectTypeDevelopment'
                }
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        setSelectedProjectType (projectType) {
            this.selectedProjectType = projectType
        },
        handleSelectItem (item) {
            this.selectedItem = item
        }
    },
    mounted () {
        this.$store.state.view = 'learning'
    },
    components: {
        'project-type-development': require('./components/projectTypeDevelopment.vue'),
        'project-type-skills': require('./components/projectTypeSkills.vue'),
        'project-type-coverage-per-hour-development': require('./components/projectTypeCoveragePerHourDevelopment.vue'),
        'claims-table': require('../employees/operations/claims.vue')
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?7d1eb384